import { isRight } from 'fp-ts/lib/Either';
import { format } from 'date-fns';
import { de } from 'date-fns/locale';
import { FreeTrialApiResponseCodec } from './freeTrialCodec';
import type { FreeTrialState } from './types';

export const formatDate = (dateString: string, dateFormat = 'dd.MM.yyyy') => {
    try {
        return format(new Date(dateString), dateFormat, { locale: de });
    } catch {
        return dateString;
    }
};

export class FreeTrialMapperError extends Error {
    constructor(message: string) {
        super(message);
        this.name = 'FreeTrialMapperError';
    }
}

export function mapFreeTrialResponse(response: unknown): FreeTrialState {
    const decoded = FreeTrialApiResponseCodec.decode(response);
    if (!isRight(decoded)) {
        throw new FreeTrialMapperError(`Invalid free-trial response: ${JSON.stringify(response)}`);
    }

    const normalizedStatus = decoded.right.status.toUpperCase() as FreeTrialState['status'];

    return {
        accountId: decoded.right.account_id,
        accountName: decoded.right.account_name,
        status: normalizedStatus,
        startDate: decoded.right.activated_at ? formatDate(decoded.right.activated_at) : null,
        endDate: decoded.right.ends_at ? formatDate(decoded.right.ends_at) : null,
    };
}
